import produce from 'immer';
import { ActionTypes } from '../actions/promocode';

export const initialState = {
    isLoading: false,
    modalIsVisible: false,
    name: '',
    value: '',
};

/* eslint-disable no-param-reassign */
function appPromocodeReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.CHANGE_VALUE:
                draft.value = action.value;
                return draft;
            case ActionTypes.CHANGE_NAME:
                draft.name = action.name;
                return draft;
            case ActionTypes.CHANGE_IS_LOADING:
                draft.isLoading = action.isLoading;
                return draft;
            case ActionTypes.CHANGE_MODAL_IS_VISIBLE:
                draft.modalIsVisible = action.isVisible;
                return draft;
            default:
                return draft;
        }
    });
}

export default appPromocodeReducer;
